import { parsePictureMd5toUrl } from "./utils.js";
export default class User {
  constructor(user, pictureDomain) {
    this.id = void 0;
    this.isConnected = () => {
      return this.id !== '0';
    };
    this.id = user.id;
    this.country = user.country;
    this.direction = user.direction;
    this.lang = user.lang;
    this.locale = user.locale;
    this.settings = user.settings;
    this.familyStatus = user.familyStatus;
    if (this.isConnected()) {
      this.blogname = user.blogname;
      this.pictureMD5 = user.pictureMD5;
      this.getPictureUrl = (width, height, color) => parsePictureMd5toUrl(pictureDomain, user.pictureMD5, width, height, color);
    }
  }
}